<template>

  <div class="container">

    <button @click="hideModal()" class="close-btn"/>
    <h1>Edit Survey</h1>

    <!-- Edit Title -->
    <div class="row">
      <div class="left">
        <p class="answer-type-icon">📝</p>
      </div>
      <div class="right">
        <h3>Survey Title</h3>
        <input
        v-model="survey.title"
        placeholder="Please enter a survey title" maxlength="500" type="text">
      </div>
    </div>

    <br/>

    <!-- Edit Intro -->
    <div class="row" v-if="survey.intro && survey.intro.text">
      <div class="left">
        <p class="answer-type-icon">👋</p>
      </div>
      <div class="right">
        <h3>Intro</h3>
        <input
        v-model="survey.intro.text"
        placeholder="Optional welcome message for respondents" maxlength="500" type="text">
      </div>
    </div>

    <br/>

    <!-- Edit Screener Questions -->
    <div v-for="(question, question_index) of survey.screener_questions" class="row">
      <div class="left">
        <p class="answer-type-icon">✅</p>
      </div>
      <div class="right">
        <h3>Screener Question {{ parseInt(question_index) + 1 }}</h3>
        <input
        v-model="question.text"
        placeholder="Please enter some question text" maxlength="500" type="text">
      </div>
    </div>

    <br/>

    <!-- Edit Questions -->
    <div v-for="(question, question_index) of survey.questions" class="row">
      <div class="left">
        <p class="answer-type-icon">{{ get_answer_type_icon(question.answer_type) }}</p>
      </div>
      <div class="right">
        <h3>Question {{ parseInt(question_index) + 1 }}</h3>
        <input
        v-model="question.text"
        placeholder="Please enter some question text" maxlength="500" type="text">
      </div>
    </div>

    <br/>

    <!-- Edit Intro -->
    <div class="row" v-if="survey.outro && survey.outro.text">
      <div class="left">
        <p class="answer-type-icon">👋</p>
      </div>
      <div class="right">
        <h3>Outro</h3>
        <input
        v-model="survey.outro.text"
        placeholder="Optional farewell message for respondents" maxlength="500" type="text">
      </div>
    </div>

    <button class="save-edits-btn" @click="saveEdits()">Save Edits</button>

  </div>

</template>

<script>

import _ from 'lodash';

export default {

  name: 'EditSurveyModal',

  props: {
    survey_index: Number,
    original_survey: Object
  },

  data: function () {
    let copy = JSON.parse(JSON.stringify(this.original_survey));
    return { survey: copy };
  },

  components: {},
  computed: {},

  methods: {

    saveEdits() {
      let edits = {};
      let survey = this.survey;
      if (survey.title) {
        edits.title = survey.title
      };
      if (survey.intro) {
        edits.intro = survey.intro;
      };
      if (survey.screener_questions) {
        edits.screener_questions = survey.screener_questions;
      };
      if (survey.questions) {
        edits.questions = survey.questions;
      };
      if (survey.outro) {
        edits.outro = survey.outro;
      };
      this.$store.dispatch('editSurvey', [this.survey_index, survey, edits]);
      this.$message.success(`Edits saved successfully`, 4);
      analytics.track('Survey Edited');
      this.hideModal();
    },

    hideModal() {
      this.$emit('hideModal');
    },

    get_answer_type_icon(answer_type) {
      switch (answer_type) {
        case 'text':
          return '✏️';
        case 'audio':
          return '🎙';
        case 'image':
          return '📷';
        case 'video':
          return '🎬';
        case 'multimedia':
          return '▶️';
        case 'multi_choice':
          return '📊';
        case 'nps':
          return '⚖️';
        case 'location':
          return '📍';
        default:
          return '';
      };
    },

  },

  mounted() {

    window.addEventListener('keyup', (event) =>  {

      // Escape Key - Close Modal
      if (event.keyCode === 27) {
        this.$emit('hideEditStudyModal');
      };

    });


  }
}
</script>

<style scoped lang="scss">

.container{
  background-color: white;
  font-family: "Montserrat", sans-serif;
  border-radius: 10px;
  position: relative;
  max-height: 800px;
  overflow-y: scroll;
  p, h2, h3, h3, h4, span{
    color: #0D303F;
  }
  padding: 40px;
}

h1{
  font-size: 18px;
  text-align: center;
}

.row{
  display: block;
  width: 100%;
  margin-bottom: 15px;
  & > *{
    display: inline-block;
  }
  h3{
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 13px;
  }
  .left{
    width: 8%;
    font-size: 20px;
  }
  .right{
    width: 90%;
  }
  input{
    width: 100%;
    height: 44px;
    color: #0D303F;
    padding-left: 14px;
    padding-right: 14px;
    background-color: rgb(246,246,246);
    border: 1px solid rgb(227,228,229);
    border-radius: 4px 4px 0px 0px;
    text-align: left;
    &:focus{
      outline: none;
    }
  }
}

.save-edits-btn{
  display: block;
  padding: 10px 24px;
  border: 1.5px solid rgb(220,220,220);
  border-radius: 4px;
  color: black;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: .5px;
  margin: 0 auto;
  opacity: .75;
  transition: all 0.2s ease;
  cursor: pointer;
  outline: none;
  &:hover{
    border: 1.5px solid rgb(190,190,190);
    opacity: 1;
  }
  &:active, &:focus{
    outline: none;
    //border-color: rgb(180,180,180);
  }
}

.divider{
  border-top: 1px solid rgb(220,220,220);
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}


.close-btn{
  position: absolute;
    top: 25px;
    right: 25px;
  width: 36px;
  height: 36px;
  background-image: url("../assets/icons/close-btn.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  background-color: transparent;
  border: none;
  opacity: .8;
  transition: all 0.2s ease;
  cursor: pointer;
  &:hover{
    opacity: 1;
  }
}


</style>
